export const subtitlesLocales = {
  articles: 'статьи',
  blogs: 'блоги',
  news: 'новости',
  questions: 'вопросы',
};

export const commentType = {
  articles: 'stati_comments',
  blogs: 'blog_comments',
  news: 'news_comments',
  questions: 'question_comments',
  survey: 'survey_comments',
};

/**
 * Для удаления различных типов комментариев нужно слать в СОПР разные данные.
 * Бэк не смог отдать идентификаторы сразу, поэтому ориентируемся на subtitle.
 * Для категорий, которые не вошли в subtitlesLocales отправляем _comments,
 * чтобы оперативно понимать, в каких категориях сериалайз работает неправильно
 * или неполон.
 * @param {string} subtitle
 * @returns {string}
 */
export function serializeCommentsType(subtitle: string = 'default'): string {
  const downcaseSubtitle = subtitle.toLowerCase();

  switch (downcaseSubtitle) {
    case subtitlesLocales.blogs:
      return commentType.blogs;
    case subtitlesLocales.news:
      return commentType.news;
    case subtitlesLocales.questions:
      return commentType.questions;
    case subtitlesLocales.articles:
      return commentType.articles;
    default:
      return '_comments';
  }
}
